<template>
    <div class="serial-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Live Class',
                    to: { path: '/live-class' },
                    exact: true,
                },
                { text: 'Tambah Live Class' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ $route.query.id ? "Ubah" : "Tambah" }} Live Class
        </h3>

        <v-layout class="pt-0 px-0 pb-3 mb" v-if="$route.query.id">
            <v-btn
                class="mr-2"
                :class="tab == 1 ? 'white--text' : 'darkFade--text'"
                :color="tab == 1 ? 'blew' : 'white'"
                elevation="0"
                @click="tab = 1"
                >Detail Kelas</v-btn
            >
            <v-btn
                :class="tab == 2 ? 'white--text' : 'darkFade--text'"
                :color="tab == 2 ? 'blew' : 'white'"
                cldass="mr-2"
                elevation="0"
                @click="tab = 2"
                >Partisipan</v-btn
            >
            <v-btn
                :class="tab == 3 ? 'white--text' : 'darkFade--text'"
                :color="tab == 3 ? 'blew' : 'white'"
                class="mr-2 ml-2"
                elevation="0"
                @click="tab = 3"
                >Upload Video dan Modul</v-btn
            >
        </v-layout>

        <v-card v-show="tab == 1" style="border">
            <v-card-title>
                Detail Kelas
                <v-spacer></v-spacer>

                <!-- <v-btn
          class="align-center text-body-2 blew white--text"
          text
          id="live_class_tambah"
          @click="dialogUploadLiveClass = true"
          ><v-icon small class="pr-2">mdi-cloud-upload</v-icon>
          Upload Live Class
        </v-btn> -->
            </v-card-title>
            <v-divider />
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            form.url
                                                ? form.url
                                                : require('@/assets/img/unavailable.png')
                                        "
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <!-- <v-btn
                @click="$refs.uploader.click()"
                block
                class="pa-0 font-weight-bold dark--text"
                color="white"
              >
                Upload *
              </v-btn>
              <input
                id="live_class_image"
                type="file"
                ref="uploader"
                class="d-none"
                accept="image/*"
                @change="onFileChange"
              /> -->

                            <v-btn
                                @click="dialogUploadImageLiveClass = true"
                                block
                                depressed
                                class="pa-0 font-weight-bold mt-3"
                                color="blew"
                                outlined
                            >
                                Pilih Gambar
                            </v-btn>
                        </v-card-text>
                        <!-- <v-card-text class="text-caption pa-0 d-flex justify-center">
              Rasio thumbnail foto 16:9
            </v-card-text>
            <v-card-text class="text-caption pa-0 d-flex justify-center">
              Maximum size is 200 KB
            </v-card-text> -->
                    </v-card>
                </v-col>
                <v-col cols="9" style="border-left: 1px solid #f0f0f0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Room *
                                    </v-list-item-title>

                                    <v-text-field
                                        v-model="form.title"
                                        id="live_class_title"
                                        placeholder="Nama Room"
                                        required
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Tipe User </v-list-item-title
                                    ><v-radio-group
                                        row
                                        v-model="form.user_type"
                                    >
                                        <v-radio
                                            id="user_type_student"
                                            label="Siswa"
                                            value="student"
                                            class="user_type_selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="user_type_teacher"
                                            label="Guru"
                                            value="teacher"
                                            class="user_type_selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="user_type_parent"
                                            label="Orang Tua"
                                            value="parent"
                                            class="user_type_selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="form.user_type === 'student'"
                                two-line
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Deskripsi
                                    </v-list-item-title>
                                    <v-textarea
                                        id="live_class_description"
                                        placeholder="Deskripsi Kelas"
                                        v-model="form.description"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="form.user_type !== 'student'"
                                two-line
                                class="mb-5"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Materi
                                    </v-list-item-title>
                                    <ckeditor
                                        :editor="editor"
                                        v-model="form.material_description"
                                        :config="editorConfig"
                                    ></ckeditor>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="form.user_type !== 'student'"
                                two-line
                                class="mb-5"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Manfaat Program
                                    </v-list-item-title>
                                    <ckeditor
                                        :editor="editor"
                                        v-model="form.program_benefit"
                                        :config="editorConfig"
                                    ></ckeditor>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Posisi </v-list-item-title
                                    ><v-radio-group row v-model="orientation">
                                        <v-radio
                                            id="orientation_landscape"
                                            label="Landscape"
                                            value="landscape"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="orientation_potrait"
                                            label="Potrait"
                                            value="potrait"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0 mb-5">
                                    <v-list-item-title
                                        v-if="form.user_type === 'student'"
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Guru *
                                    </v-list-item-title>
                                    <v-list-item-title
                                        v-if="form.user_type !== 'student'"
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Narasumber *
                                    </v-list-item-title>

                                    <v-combobox
                                        v-model="teachers"
                                        :items="teacherList"
                                        item-text="name"
                                        item-value="name"
                                        :search-input.sync="search"
                                        placeholder="Pilih atau ketik nama pengisi live class"
                                        hide-selected
                                        hint="Maksimal 4 nama"
                                        multiple
                                        chips
                                        persistent-hint
                                        outlined
                                    >
                                        <template v-slot:no-data>
                                            <v-list-item two-line>
                                                <v-list-item-content
                                                    class="pa-0"
                                                >
                                                    <v-list-item-title>
                                                        Tidak ditemukan "<strong
                                                            >{{
                                                                search
                                                            }}</strong
                                                        >". Tekan
                                                        <strong>enter</strong>
                                                        untuk input nama baru
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        v-if="form.user_type !== 'student'"
                                        class="font-weight-bold pb-2"
                                    >
                                        Detail Narasumber
                                    </v-list-item-title>
                                    <v-list-item-title
                                        v-if="form.user_type === 'student'"
                                        class="font-weight-bold pb-2"
                                    >
                                        Detail Guru
                                    </v-list-item-title>

                                    <v-textarea
                                        id="live_class_teacher_details"
                                        v-model="form.teacher_details"
                                        placeholder="Deskripsi pengisi live class"
                                        required
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Jenis Kelas </v-list-item-title
                                    ><v-radio-group row v-model="form.type">
                                        <v-radio
                                            id="live_class_type_free"
                                            label="Free"
                                            value="FREE"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="live_class_type_premium"
                                            label="Premium"
                                            value="PREMIUM"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <!-- <v-list-item two-line>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="font-weight-bold pb-2">
                    Kuota *
                  </v-list-item-title>
                  <v-text-field
                    id="live_class_kuota"
                    v-model="form.kuota"
                    type="number"
                    placeholder="Kuota Partisipan"
                    outlined
                  />
                </v-list-item-content>
              </v-list-item> -->
                            <v-list-item
                                v-if="form.user_type === 'student'"
                                two-line
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Mata Pelajaran
                                    </v-list-item-title>

                                    <v-select
                                        id="live_class_mapel"
                                        class="pa-0"
                                        v-model="form.mapel"
                                        :items="mapelList"
                                        outlined
                                        item-text="nama"
                                        item-value="id"
                                        placeholder="Ketik mata pelajaran"
                                        chips
                                    >
                                        <template v-slot:selection="{ item }">
                                            <v-list-item class="pa-0 ma-0">
                                                <v-list-item-avatar>
                                                    <img :src="item.picture" />
                                                </v-list-item-avatar>
                                                <v-list-item-title>{{
                                                    item.nama
                                                }}</v-list-item-title>
                                            </v-list-item>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <v-list-item-avatar>
                                                <img :src="item.picture" />
                                            </v-list-item-avatar>
                                            <v-list-item-title>{{
                                                item.nama
                                            }}</v-list-item-title>
                                        </template>
                                    </v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="form.user_type === 'student'"
                                two-line
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Jenjang
                                    </v-list-item-title>

                                    <v-radio-group
                                        row
                                        v-model="form.level"
                                        @change="form.grade = []"
                                    >
                                        <v-radio
                                            id="live_class_jenjang_sd"
                                            label="SD"
                                            value="SD"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="live_class_jenjang_smp"
                                            label="SMP"
                                            value="SMP"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="live_class_jenjang_sma"
                                            label="SMA"
                                            value="SMA"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="form.user_type === 'student'"
                                two-line
                            >
                                <v-list-item-content class="pa-0 mb-5">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Kelas
                                    </v-list-item-title>
                                    <div
                                        v-if="form.level === 'SD'"
                                        class="d-inline d-flex"
                                        style="gap: 12px"
                                    >
                                        <v-checkbox
                                            id="live_class_kelas_1"
                                            label="1"
                                            :value="1"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_2"
                                            label="2"
                                            :value="2"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_3"
                                            label="3"
                                            :value="3"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_4"
                                            label="4"
                                            :value="4"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_5"
                                            label="5"
                                            :value="5"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_6"
                                            label="6"
                                            :value="6"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                    </div>
                                    <div
                                        v-if="form.level === 'SMP'"
                                        class="d-inline d-flex"
                                        style="gap: 12px"
                                    >
                                        <v-checkbox
                                            id="live_class_kelas_7"
                                            label="7"
                                            :value="7"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_8"
                                            label="8"
                                            :value="8"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_9"
                                            label="9"
                                            :value="9"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                    </div>
                                    <div
                                        v-if="form.level === 'SMA'"
                                        class="d-inline d-flex"
                                        style="gap: 12px"
                                    >
                                        <v-checkbox
                                            id="live_class_kelas_10"
                                            label="10"
                                            :value="10"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_11"
                                            label="11"
                                            :value="11"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                        <v-checkbox
                                            id="live_class_kelas_12"
                                            label="12"
                                            :value="12"
                                            v-model="form.grade"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Youtube URL
                                    </v-list-item-title>
                                    <v-text-field
                                        id="live_class_youtube_url"
                                        v-model="form.youtubeUrl"
                                        placeholder="https://"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-row>
                                <v-col cols="6">
                                    <v-list-item two-line>
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title
                                                class="font-weight-bold pb-2"
                                            >
                                                Room Url
                                            </v-list-item-title>
                                            <v-text-field
                                                id="live_class_room_url"
                                                v-model="form.room_url"
                                                placeholder="https://"
                                                outlined
                                            />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="6">
                                    <v-list-item two-line>
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title
                                                class="font-weight-bold pb-2"
                                            >
                                                ID Room
                                            </v-list-item-title>
                                            <v-text-field
                                                id="live_class_meeting_id"
                                                v-model="form.meeting_id"
                                                placeholder="ID Zoom"
                                                outlined
                                            />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Room Password
                                    </v-list-item-title>
                                    <v-text-field
                                        id="live_class_room_password"
                                        v-model="form.room_password"
                                        placeholder="Password"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Join Code
                                    </v-list-item-title>
                                    <v-text-field
                                        id="live_class_join_code"
                                        v-model="form.joinCode"
                                        placeholder="Maksimal 10 karakter"
                                        :value="
                                            form.joinCode =
                                                form.joinCode.toUpperCase()
                                        "
                                        maxlength="10"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Opsi
                                    </v-list-item-title>
                                    <div class="d-inline mb-5">
                                        <v-checkbox
                                            id="live_class_opsi_private"
                                            label="Private"
                                            v-model="form.isPrivate"
                                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                                            outlined
                                        />
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                two-line
                                v-if="
                                    form.type == 'PREMIUM' &&
                                    form.user_type === 'student'
                                "
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Jadwal Kelas
                                    </v-list-item-title>

                                    <v-card
                                        class="my-3 test_cursor"
                                        outlined
                                        v-for="(tryout, index) in tryouts"
                                        v-bind:key="index"
                                    >
                                        <v-list class="pa-2 text-subtitle-2">
                                            <template>
                                                <v-list-item two-line>
                                                    <v-list-item-content
                                                        class="mx-2 my-0 align-self-start"
                                                        style="max-width: 5%"
                                                    >
                                                        <v-list-item-subtitle
                                                            class="font-weight-bold"
                                                        >
                                                            ID
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle
                                                            style="
                                                                text-overflow: unset;
                                                                white-space: unset;
                                                            "
                                                        >
                                                            {{ tryout.id }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content
                                                        class="mx-2 my-0 align-self-start"
                                                        style="max-width: 20%"
                                                    >
                                                        <v-list-item-subtitle
                                                            class="font-weight-bold"
                                                        >
                                                            Deskripsi
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle
                                                            style="
                                                                text-overflow: unset;
                                                                white-space: unset;
                                                            "
                                                        >
                                                            {{ tryout.desc }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content
                                                        class="mx-2 my-0 align-self-start"
                                                        style="max-width: 10%"
                                                    >
                                                        <v-list-item-subtitle
                                                            class="font-weight-bold"
                                                        >
                                                            Kuota
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle
                                                            style="
                                                                text-overflow: unset;
                                                                white-space: unset;
                                                            "
                                                        >
                                                            {{ tryout.quota }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content
                                                        class="mx-2 my-0 align-self-start"
                                                        style="max-width: 15%"
                                                    >
                                                        <v-list-item-subtitle
                                                            class="font-weight-bold"
                                                        >
                                                            Threshold
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle
                                                            style="
                                                                text-overflow: unset;
                                                                white-space: unset;
                                                            "
                                                        >
                                                            {{
                                                                tryout.threshold
                                                            }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content
                                                        class="mx-2 my-0 align-self-start"
                                                        style="max-width: 15%"
                                                    >
                                                        <v-list-item-subtitle
                                                            class="font-weight-bold"
                                                        >
                                                            Start Time
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle
                                                            style="
                                                                text-overflow: unset;
                                                                white-space: unset;
                                                            "
                                                        >
                                                            {{
                                                                tryout.start_time
                                                            }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content
                                                        class="mx-2 my-0 align-self-start"
                                                    >
                                                        <v-list-item-subtitle
                                                            class="font-weight-bold"
                                                        >
                                                            End Time
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            {{
                                                                tryout.end_time
                                                            }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-btn
                                                            plain
                                                            class="pa-0"
                                                            @click="
                                                                removeTryoutFromGroup(
                                                                    index,
                                                                )
                                                            "
                                                        >
                                                            <span
                                                                class="red--text"
                                                                :class="
                                                                    $vuetify
                                                                        .breakpoint
                                                                        .mdAndUp
                                                                        ? 'font-weight-700'
                                                                        : 'font-weight-600'
                                                                "
                                                                :style="
                                                                    $vuetify
                                                                        .breakpoint
                                                                        .smAndDown
                                                                        ? 'font-size: 12px'
                                                                        : ''
                                                                "
                                                                >Hapus</span
                                                            >
                                                        </v-btn>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </v-card>
                                    <app-jadwalkelaschooser
                                        v-on:selected="
                                            addTryoutIntoGroup($event)
                                        "
                                        class="mb-8 mt-2"
                                    ></app-jadwalkelaschooser>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-row>
                                    <v-col cols="6">
                                        <v-list-item two-line class="pa-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Waktu Mulai *
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            class="pa-0"
                                                        >
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    startDate.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="live_class_start_date"
                                                                        v-model="
                                                                            startDate.value
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-if="
                                                                        startDate.option
                                                                    "
                                                                    v-model="
                                                                        startDate.value
                                                                    "
                                                                    :min="
                                                                        new Date()
                                                                            .toISOString()
                                                                            .slice(
                                                                                0,
                                                                                10,
                                                                            )
                                                                    "
                                                                    no-title
                                                                    @change="
                                                                        startDate.option = false
                                                                    "
                                                                    scrollable
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    startTime.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                :nudge-right="
                                                                    40
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="live_class_start_time"
                                                                        v-model="
                                                                            startTime.value
                                                                        "
                                                                        outlined
                                                                        placeholder="Jam"
                                                                        append-icon="mdi-clock-time-four-outline"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="
                                                                        startTime.option
                                                                    "
                                                                    v-model="
                                                                        startTime.value
                                                                    "
                                                                    @change="
                                                                        startTime.option = false
                                                                    "
                                                                    format="24hr"
                                                                ></v-time-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6" class="pa-0">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Waktu Berakhir *
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            class="pa-0"
                                                        >
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    endDate.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="live_class_end_date"
                                                                        v-model="
                                                                            endDate.value
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-if="
                                                                        endDate.option
                                                                    "
                                                                    v-model="
                                                                        endDate.value
                                                                    "
                                                                    :min="
                                                                        new Date()
                                                                            .toISOString()
                                                                            .slice(
                                                                                0,
                                                                                10,
                                                                            )
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                    @change="
                                                                        endDate.option = false
                                                                    "
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    endTime.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                :nudge-right="
                                                                    40
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="live_class_end_time"
                                                                        v-model="
                                                                            endTime.value
                                                                        "
                                                                        outlined
                                                                        placeholder="Jam"
                                                                        append-icon="mdi-clock-time-four-outline"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="
                                                                        endTime.option
                                                                    "
                                                                    v-model="
                                                                        endTime.value
                                                                    "
                                                                    @change="
                                                                        endTime.option = false
                                                                    "
                                                                    format="24hr"
                                                                ></v-time-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pt-0 px-0 pb-6">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        User Group *
                                    </v-list-item-title>
                                    <v-autocomplete
                                        :items="user_groups"
                                        item-text="user_group_name"
                                        item-value="id"
                                        class="pb-2"
                                        placeholder="-- Pilih user group --"
                                        outlined
                                        v-for="(usgr, i) in form.user_group"
                                        :key="i"
                                        v-model="form.user_group[i]"
                                    >
                                        <template v-slot:append-outer>
                                            <v-btn
                                                id="user-remove-scope-btn"
                                                dark
                                                x-large
                                                class="font-weight-bold dark--text py-3"
                                                depressed
                                                color="white"
                                                elevation="1"
                                                v-if="
                                                    i ===
                                                        form.user_group.length -
                                                            1 &&
                                                    form.user_group.length != 1
                                                "
                                                @click="
                                                    queryId
                                                        ? null
                                                        : form.user_group.splice(
                                                              i,
                                                              1,
                                                          )
                                                "
                                            >
                                                Hapus
                                            </v-btn>
                                        </template>
                                    </v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>
                            <v-container>
                                <v-btn
                                    id="user-add-scope-btn"
                                    @click="form.user_group.push('')"
                                    block
                                    depressed
                                    class="font-weight-bold blew--text mb-5"
                                    color="#e8f5fa"
                                >
                                    <v-icon
                                        style="font-size: 16px !important"
                                        class="mr-1"
                                    >
                                        mdi-plus-circle
                                    </v-icon>
                                    Tambah User Group Baru
                                </v-btn>
                            </v-container>
                        </v-card-text>

                        <v-card-actions class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                depressed
                                class="px-6 py-2 white--text"
                                color="blew"
                                @click="upload()"
                                id="live_class_simpan"
                                >Simpan</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>

        <v-card v-if="$route.query.id" v-show="tab == 2" style="border">
            <v-card-title>
                Daftar Partisipan

                <v-btn
                    v-if="countStudents"
                    class="darkGreen--text font-weight-600 ml-3"
                    elevation="0"
                    color="backgroundGreen"
                    rounded
                    small
                >
                    <v-icon small>mdi mdi-account-multiple-outline</v-icon>
                    {{ countStudents }} Siswa
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>
            <v-container fluid class="pa-4">
                <v-row no-gutters>
                    <v-col>
                        <v-text-field
                            v-model="params.search"
                            outlined
                            height="36px"
                            hide-details
                            small
                            dense
                            class="search_box"
                            @keyup.enter="searchMember()"
                            placeholder="Ketik kata kunci dan tekan enter"
                        />
                    </v-col> </v-row
            ></v-container>

            <v-card-text class="pt-0" style="margin-top: -10px">
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Nama</th>
                                <th class="text-left">Email</th>
                                <th class="text-center">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(student, index) in students"
                                v-bind:key="index"
                            >
                                <td>
                                    <v-btn
                                        fab
                                        class="user-avatar font-weight-500"
                                        dark
                                        depressed
                                        x-small
                                        style="
                                            text-transform: uppercase !important;
                                            letter-spacing: 0.5pt !important;
                                        "
                                        :color="getColorAvatar(student.name)"
                                    >
                                        {{ getAcronimeName(student.name) }}
                                    </v-btn>

                                    <span class="ml-3">{{ student.name }}</span>
                                </td>
                                <td>{{ student.email }}</td>
                                <td class="text-center">
                                    <v-btn
                                        v-if="status == 'ATTENDED'"
                                        class="blew--text font-weight-600"
                                        color="touchBlue"
                                        rounded
                                        small
                                    >
                                        Attended
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        class="darkGreen--text font-weight-600"
                                        elevation="0"
                                        color="backgroundGreen"
                                        rounded
                                        small
                                    >
                                        Joined
                                    </v-btn>
                                </td>
                            </tr>

                            <tr v-if="!students.length && !isLoading">
                                <td colspan="3" align="center">
                                    {{
                                        params.search
                                            ? "Partisipan tidak ditemukan"
                                            : "Tidak ada partisipan untuk Live Class ini"
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <div class="d-flex mt-5" style="justify-content: end">
                    <v-spacer />
                    <v-pagination
                        v-model="params.page"
                        :length="params.maxpage"
                        @input="changePage"
                    ></v-pagination>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-if="$route.query.id" v-show="tab == 3" style="border">
            <v-card plain class="pa-7">
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Youtube URL Recording
                        </v-list-item-title>
                        <v-text-field
                            placeholder="Masukkan URL Video dan tekan enter"
                            v-model="form.youtubeUrl"
                            outlined
                        />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Durasi Video
                        </v-list-item-title>
                        <v-text-field
                            type="number"
                            placeholder="Durasi (dalam detik)"
                            v-model="record_video_duration"
                            outlined
                        />
                    </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item two-line class="pa-0">
          <v-list-item-content class="pa-0">
            <v-list-item-title class="font-weight-bold pb-2">
              Nama Modul *
            </v-list-item-title>
            <v-text-field
              placeholder="Nama Modul"
              v-model="presentationName"
              outlined
            />
          </v-list-item-content>
        </v-list-item> -->
                <v-list-item two-line class="px-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Upload Modul
                        </v-list-item-title>
                        <v-card>
                            <v-card-text class="d-flex">
                                <div>
                                    <v-btn
                                        @click="$refs.uploader2.click()"
                                        class="blue--text"
                                        elevation="0"
                                        >Upload File
                                    </v-btn>
                                    <input
                                        type="file"
                                        ref="uploader2"
                                        class="d-none"
                                        accept="application/pdf"
                                        @change="onFileChange2"
                                    />
                                </div>
                            </v-card-text>
                            <p class="ml-5 mb-5 mt-0 grey--text">
                                File dalam bentuk PDF dan maksimal ukuran file 2
                                MB
                            </p>
                        </v-card>
                    </v-list-item-content>
                </v-list-item>
                <div v-if="presentationPath" class="form-group">
                    <div class="pdf-container ml-5">
                        <embed
                            :src="presentationPath"
                            type="application/pdf"
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <p class="ml-5 mb-2 mt-2">
                        {{ presentationName }}
                    </p>
                    <p class="ml-5 mb-5 mt-0">
                        {{ presentationSize }}
                    </p>
                </div>

                <v-divider></v-divider>
                <v-card-actions class="py-2">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary"
                        class="mt-3"
                        depressed
                        @click="upload2()"
                    >
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-card>

        <app-upload-image-liveclass
            v-if="dialogUploadImageLiveClass"
            @closeDialog="dialogUploadImageLiveClass = false"
            @selected="selectedImage($event)"
        ></app-upload-image-liveclass>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import AWS from "aws-sdk";
import { applyOssCredentials } from "@/modules/global/services/oss";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Jadwalkelaschooser from "@/modules/pembayaran/components/JadwalKelasChooser";
import LiveClassService from "@/modules/live_class/services/liveclass.js";
import Moment, { now } from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import uniqid from "uniqid";
import axios from "axios";
import UploadImage from "./UploadImage.vue";

export default {
    name: "LiveclassForm",

    components: {
        "app-autocomplete": Autocomplete,
        "app-jadwalkelaschooser": Jadwalkelaschooser,
        "app-spinner": Spinner,
        "app-upload-image-liveclass": UploadImage,
    },

    data: function () {
        return {
            tab: 1,
            url: null,
            presentationPath: null,
            presentationFile: null,
            presentation: null,
            presentationName: null,
            presentationSize: null,
            queryId: null,
            startDate: {
                option: false,
                value: null,
            },
            startTime: {
                option: false,
                value: null,
            },
            endTime: {
                option: false,
                value: null,
            },
            endDate: {
                option: false,
                value: null,
            },
            isLoading: false,
            thumbnail: null,
            teachers: [],
            changeUrl: true,
            videoId: null,
            successbyurl: false,
            form: {
                id: null,
                title: null,
                url: null,
                room_password: null,
                mapel: false,
                isPrivate: false,
                description: "",
                meeting_id: null,
                room_url: null,
                youtubeUrl: null,
                topic: null,
                teachers: [],
                teacher_details: null,
                // kuota: null,
                babId: null,
                subBabId: null,
                subSubBabId: null,
                joinCode: "",
                level: "SD",
                locationNumber: 4,
                type: "FREE",
                grade: [],
                isLoading: false,
                groups: [],
                stack: [],
                topics: [],
                groupId: [],
                user_group: [],
                user_type: "student",
                material_description: "",
                program_benefit: "",
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                    "|",
                    "outdent",
                    "indent",
                ],
            },
            tryouts: [],
            search: null,
            array: [],
            teacherList: [],
            imageFile: null,
            errors: [],
            mapelList: JSON.parse(localStorage.getItem("mapels")),
            students: [],
            countStudents: 0,
            params: {
                search: "",
                page: 1,
                size: 10,
                maxpage: 1,
            },
            pageNumber: 1,
            user_groups: [],
            orientation: "landscape",
            dialogUploadImageLiveClass: false,
        };
    },

    watch: {
        pageNumber() {
            if (this.pageNumber > 0) {
                if (this.pageNumber <= this.params.maxpage) {
                    this.params.page = this.pageNumber;
                    this.getListMembers();
                } else {
                    this.pageNumber = this.params.page;
                    alert(
                        "Data Hanya sampai " + this.params.maxpage + " halaman",
                    );
                }
            } else if (this.pageNumber < 1) this.pageNumber = 1;
        },

        teachers(val) {
            if (val.length > 4) {
                this.$nextTick(() => this.teachers.pop());
            }
        },
    },

    computed: {
        gradeLevel() {
            switch (Number(this.form.level)) {
                case 0:
                    return [4, 5, 6];
                    break;
                case 1:
                    return [7, 8, 9];
                    break;
                case 2:
                    return [10, 11, 12];
                    break;
                default:
                    return [4, 5, 6];
                    break;
            }
        },

        player() {
            return this.$refs.youtube.player;
        },

        record_video_url: {
            get: function () {
                return this.$store.state.liveclass.record_video_url;
            },

            set: function (value) {
                this.$store.commit("liveclass_set_record_video_url", value);
            },
        },

        record_video_duration: {
            get: function () {
                return this.$store.state.liveclass.record_video_duration;
            },

            set: function (value) {
                this.$store.commit(
                    "liveclass_set_record_video_duration",
                    value,
                );
            },
        },
    },

    methods: {
        changePage(newPage) {
            this.params.page = newPage;
            this.getListMembers();
        },

        searchMember() {
            this.params.page = 1;
            this.getListMembers();
        },

        getTeachers() {
            const context = this;
            context.teacherList = [];
            LiveClassService.getTeachers(function (result) {
                if (result.success) {
                    result.data.forEach(function (item) {
                        var row = {
                            id: item.id,
                            name: item.teacher_name,
                        };
                        context.teacherList.push(row);
                    });
                }
            });
        },

        getListMembers() {
            const context = this;
            // context.students = [];
            context.isLoading = true;
            LiveClassService.getListMembers(
                this.$route.query.id,
                this.params,
                function (response) {
                    if (response.success) {
                        context.students = response.data.list_detail_classes;
                        context.params.maxpage = response.data.max_page;
                        context.countStudents = response.data.total_member;
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data Members kelas!`,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                },
            );
        },

        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.form.url = URL.createObjectURL(file);
        },

        onFileChange2(e) {
            const file = e.target.files[0];
            this.presentationName = file.name;
            this.presentationSize = file.size;

            if (file.size > 200000000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 2 MB!`,
                    type: "error",
                });
                return;
            }

            this.presentation = file;
            this.presentationPath = URL.createObjectURL(file);
        },

        async upload(e) {
            this.isLoading = true;
            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.form.thumbnail && !file) {
                    this.thumbnail = this.form.thumbnail;
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan pada upload!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET, // 'bonf-files',
                        Key: "live_class/" + file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan pada upload!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.thumbnail = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        async upload2(e) {
            this.isLoading = true;
            if (this.validateForm()) {
                var file = this.presentation;
                if (this.presentationPath && !file) {
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("pdf") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan pada upload!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET, // 'bonf-files',
                        Key: "presentation_liveclass/" + file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan pada upload!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.presentationPath = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        validateForm: function () {
            var err = false;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            if (
                this.form.title == "" ||
                this.form.title == " " ||
                this.form.title == null
            ) {
                this.$store.commit("showAlert", {
                    message: `Nama room wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.teachers) {
                this.$store.commit("showAlert", {
                    message: `Nama pengisi wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (this.form.isPrivate && this.form.joinCode == "") {
                this.$store.commit("showAlert", {
                    message: `Join Code wajib di isi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.thumbnail && !this.form.url) {
                this.$store.commit("showAlert", {
                    message: `Room Thumbnail wajib di isi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.startDate.value) {
                this.$store.commit("showAlert", {
                    message: `Tanggal mulai wajib di isi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.endDate.value) {
                this.$store.commit("showAlert", {
                    message: `Tanggal selesai wajib di isi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.startTime.value) {
                this.$store.commit("showAlert", {
                    message: `Jam mulai wajib di isi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.endTime.value) {
                this.$store.commit("showAlert", {
                    message: `Jam selesai wajib di isi!`,
                    type: "error",
                });
                err = true;
            } else if (this.form.user_group.length < 1) {
                this.$store.commit("showAlert", {
                    message: `User Group wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (this.presentationPath === "" && this.$route.query.id) {
                this.$store.commit("showAlert", {
                    message: `File PPT wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            var startedtime = this.startDate.value + " " + this.startTime.value;
            var classOpened = Moment(startedtime).valueOf();

            var endedtime = this.endDate.value + " " + this.endTime.value;
            var classEnded = Moment(endedtime).valueOf();

            if (classOpened > classEnded) {
                this.$store.commit("showAlert", {
                    message: `Waktu akhir lebih awal daripada waktu mulai`,
                    type: "error",
                });

                err = true;
            }

            // else if (!this.form.kuota && this.form.type == "FREE") {
            //   this.$store.commit("showAlert", {
            //     message: `Kuota Kelas wajib diisi!`,
            //     type: "error",
            //   });
            //   err = true;
            // }
            return !err;
        },

        findmapel(data) {
            const found = this.mapelList.find((mapel) => mapel.nama == data);
            return found;
        },

        onSubmit() {
            if (this.$route.query.id) {
                this.upload();
            } else {
                this.upload();
            }
        },

        save() {
            var context = this;
            if (this.validateForm()) {
                var startedtime =
                    this.startDate.value + " " + this.startTime.value;
                var classOpened = Moment(startedtime).valueOf();

                var endedtime = this.endDate.value + " " + this.endTime.value;
                var classEnded = Moment(endedtime).valueOf();

                let arr = [];
                context.teachers.forEach((value) => {
                    var data = [];
                    if (value.name == undefined) {
                        data = {
                            id: null,
                            teacher_name: value,
                        };
                    } else {
                        data = {
                            id: value.id,
                            teacher_name: value.name,
                        };
                    }
                    arr.push(data);
                });

                var gradeNew;
                if (this.form.grade) {
                    gradeNew = this.getUniqueListBy(this.form.grade);
                } else {
                    gradeNew = [];
                }

                var dataCreate = {
                    name: this.form.title,
                    description: this.form.description,
                    subject: this.form.mapel,
                    teacherDetails: this.form.teacher_details,
                    teachers: arr,
                    roomUrl: this.form.room_url,
                    youtubeUrl: this.form.youtubeUrl,
                    meetingId: this.form.meeting_id,
                    roomPassword: this.form.room_password,
                    level: this.form.level,
                    grade: gradeNew, // this.form.grade,
                    type: this.form.type,
                    groupId: this.form.groupId,
                    isPrivate: this.form.isPrivate,
                    code: this.form.joinCode,
                    thumbnail: this.thumbnail,
                    // quota: this.form.kuota,
                    startAt: classOpened,
                    endAt: classEnded,
                    user_group_id: this.form.user_group_id,
                    user_group: this.getUniqueListBy(this.form.user_group), // this.form.user_group,
                    is_special: this.orientation === "potrait" ? true : false,
                    user_type: this.form.user_type,
                    material_description: this.form.material_description,
                    program_benefit: this.form.program_benefit,
                };

                var dataUpdate = {
                    id: this.$route.query.id,
                    name: this.form.title,
                    description: this.form.description,
                    subject: this.form.mapel,
                    teacherDetails: this.form.teacher_details,
                    teachers: arr,
                    roomUrl: this.form.room_url,
                    youtubeUrl: this.form.youtubeUrl,
                    meetingId: this.form.meeting_id,
                    roomPassword: this.form.room_password,
                    level: this.form.level,
                    grade: gradeNew, // this.form.grade,
                    type: this.form.type,
                    groupId: this.form.groupId,
                    isPrivate: this.form.isPrivate,
                    code: this.form.joinCode,
                    thumbnail: this.thumbnail,
                    record_video_url: this.form.youtubeUrl,
                    record_video_duration: this.record_video_duration,
                    presentationPath: this.presentationPath,
                    // quota: this.form.kuota,
                    startAt: classOpened,
                    endAt: classEnded,
                    user_group_id: this.form.user_group_id,
                    user_group: this.getUniqueListBy(this.form.user_group), // this.form.user_group,
                    is_special: this.orientation === "potrait" ? true : false,
                    user_type: this.form.user_type,
                    material_description: this.form.material_description,
                    program_benefit: this.form.program_benefit,
                };

                if (this.$route.query.id) {
                    dataUpdate.id = this.$route.query.id;

                    if (dataUpdate.user_group[0] === "") {
                        context.$store.commit("showAlert", {
                            message: `User group harus diisi!`,
                            type: "error",
                        });

                        context.isLoading = false;
                    } else {
                        LiveClassService.editLiveClass(
                            dataUpdate,
                            function (response) {
                                if (response.success) {
                                    if (
                                        response.data.description ==
                                        "Failed to Record Data"
                                    ) {
                                        context.$store.commit("showAlert", {
                                            message: `Gagal menyimpan data!`,
                                            type: "error",
                                        });
                                    } else if (
                                        response.data.description ==
                                            "At least 1 teacher is admin" &&
                                        context.form.user_type === "student"
                                    ) {
                                        context.$store.commit("showAlert", {
                                            message: `Setidaknya satu teacher adalah admin!`,
                                            type: "error",
                                        });
                                    } else {
                                        context.$store.commit("showAlert", {
                                            message: `Berhasil Menyimpan Data!`,
                                            type: "success",
                                        });
                                        context.$router.push("/live-class");
                                    }
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal menyimpan data!`,
                                        type: "error",
                                    });
                                }

                                context.isLoading = false;
                            },
                        );
                    }
                } else {
                    LiveClassService.createLiveClass(
                        dataCreate,
                        function (response) {
                            if (response.success) {
                                context.$store.commit(
                                    "live_class_init",
                                    dataCreate,
                                );
                                if (
                                    response.data.description ==
                                    "Failed to Record Data"
                                ) {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal menyimpan data!`,
                                        type: "error",
                                    });
                                } else if (
                                    response.data.description ==
                                        "At least 1 teacher is admin" &&
                                    context.form.user_type === "student"
                                ) {
                                    context.$store.commit("showAlert", {
                                        message: `Setidaknya satu teacher adalah admin!`,
                                        type: "error",
                                    });
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil Menyimpan Data!`,
                                        type: "success",
                                    });
                                    context.$router.push("/live-class");
                                }
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan data!`,
                                    type: "error",
                                });
                            }

                            context.isLoading = false;
                        },
                    );
                }
            } else {
                this.isLoading = false;
            }
        },

        addTryoutIntoGroup: function (tryout) {
            const datas = {
                id: tryout.id,
                desc: tryout.description,
                quota: tryout.quota,
                threshold: tryout.threshold,
                start_time: tryout.start_time,
                end_time: tryout.end_time,
            };
            this.form.groupId.push(tryout.id);
            this.tryouts.push(datas);
        },

        removeTryoutFromGroup: function (index) {
            var confirmed = window.confirm(
                "Apakah anda yakin akan melepas Jadwal ini?",
            );

            if (confirmed) {
                this.form.groupId.splice(index, 1);
                this.tryouts.splice(index, 1);
            }
        },

        getClasses() {
            const context = this;
            SalesService.getListJadwalKelas(function (result) {
                if (result.success) {
                    context.form.groupId.forEach(function (content) {
                        var found = result.data.find((e) => e.id == content);

                        found.desc = found.description;
                        if (found) context.tryouts.push(found);
                    });
                }
            });
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.user_groups = response.data.user_groups;
                }
            });
        },

        async getDetailClass() {
            const context = this;
            try {
                axios
                    .get(
                        `${process.env.API_BASE_URL}liveclass/getdetailclass/${this.$route.query.id}`,
                    )
                    .then((response) => {
                        console.log(response.data);
                    });
            } catch (error) {
                console.log(error);
            }
        },

        getUniqueListBy(arr) {
            // return [...new Map(arr.map((item) => [item[key], item])).values()];
            return arr.filter(
                (value, index, array) => array.indexOf(value) === index,
            );
        },

        getColorAvatar(name) {
            const initial_name = name.substring(0, 1);
            var color = "red";

            if (initial_name === "A") {
                color = "#1ABC9C";
            } else if (initial_name === "B") {
                color = "#048269";
            } else if (initial_name === "C") {
                color = "#F1C40F";
            } else if (initial_name === "D") {
                color = "#D28304";
            } else if (initial_name === "E") {
                color = "#2ECC71";
            } else if (initial_name === "F") {
                color = "#08853D";
            } else if (initial_name === "G") {
                color = "#D35400";
            } else if (initial_name === "H") {
                color = "#923A00";
            } else if (initial_name === "I") {
                color = "#3498DB";
            } else if (initial_name === "J") {
                color = "#0968A6";
            } else if (initial_name === "K") {
                color = "#E74C3C";
            } else if (initial_name === "L") {
                color = "#AE2719";
            } else if (initial_name === "M") {
                color = "#8E44AD";
            } else if (initial_name === "N") {
                color = "#9B59B6";
            } else if (initial_name === "O") {
                color = "#8FB7D1";
            } else if (initial_name === "P") {
                color = "#34495E";
            } else if (initial_name === "Q") {
                color = "#1A2A3A";
            } else if (initial_name === "R") {
                color = "#7F8C8D";
            } else if (initial_name === "S") {
                color = "#737778";
            } else if (initial_name === "T") {
                color = "#EC87BF";
            } else if (initial_name === "U") {
                color = "#A63979";
            } else if (initial_name === "V") {
                color = "#F69785";
            } else if (initial_name === "W") {
                color = "#9BA37E";
            } else if (initial_name === "X") {
                color = "#B49255";
            } else if (initial_name === "Y") {
                color = "#AE2719";
            } else if (initial_name === "Z") {
                color = "#A94136";
            }

            return color;
        },

        getAcronimeName(name) {
            const split_name = name.split(" ");
            const initial_name =
                split_name.length > 1
                    ? `${split_name[0].substr(0, 1)}${split_name[1].substr(0, 1)}`
                    : split_name[0].substr(0, 1);

            return initial_name;
        },

        selectedImage(file) {
            this.dialogUploadImageLiveClass = false;
            this.form.thumbnail = file;
            this.form.url = file;
        },
    },

    destroyed() {
        this.$store.commit("live_class_clearyoutubeUrl");
    },

    mounted: function () {
        var context = this;
        context.form.grade = [];

        var token = context.$ls.get("token");
        const options = {
            headers: {
                Authorization: token,
            },
        };

        if (context.$route.query.id) {
            axios
                .get(
                    `${process.env.API_BASE_URL}liveclass/admin/detailclass/${context.$route.query.id}`,
                    options,
                )
                .then((response) => {
                    context.$store.commit("live_class_init", response.data);
                    context.form = context.$store.state.liveclass;

                    let arrTeacher = [];
                    context.$store.state.liveclass.teachers.forEach((value) => {
                        var data = [];
                        data = {
                            id: value.id,
                            name: value.teacher_name,
                        };
                        arrTeacher.push(data);
                    });

                    // context.form.user_group = context.$store.state.liveclass.user_group;

                    context.startTime.value = context.form.startTime;
                    context.endTime.value = context.form.endTime;
                    context.teachers = arrTeacher;
                    context.form.type =
                        context.$store.state.liveclass.type || "FREE";
                    context.form.groupId =
                        context.$store.state.liveclass.groupId || [];
                    context.record_video_url = context.form.youtubeUrl;
                    context.record_video_duration =
                        context.$store.state.liveclass.record_video_duration;
                    context.presentationPath =
                        context.$store.state.liveclass.presentationPath;
                    if (
                        context.form.user_group === undefined ||
                        context.form.user_group === null
                    ) {
                        context.form.user_group = [];
                    }
                    context.thumbnail = context.$store.state.liveclass.url;
                    context.orientation =
                        context.$store.state.liveclass.is_special === true
                            ? "potrait"
                            : "landscape";

                    context.getListMembers();
                    context.getClasses();

                    var checkmapel;
                    setTimeout(() => {
                        checkmapel = context.findmapel(context.form.mapel);
                        context.form.mapel = checkmapel.id;
                    }, 1000);

                    context.startDate.value = Moment(
                        context.form.startDate,
                        "DD/MM/YYYY",
                    ).format("YYYY-MM-DD");

                    context.startTime.value = context.form.startTime;
                    context.endDate.value = Moment(
                        context.form.endDate,
                        "DD/MM/YYYY",
                    ).format("YYYY-MM-DD");
                    context.endTime.value = context.form.endTime;

                    var userGroup = [];
                    if (context.form.user_group.length > 0) {
                        for (
                            var i = 0;
                            i < context.form.user_group.length;
                            i++
                        ) {
                            userGroup.push(context.form.user_group[i]);
                        }
                    }
                });
        }

        context.getTeachers();

        if (!context.startDate) {
            context.startDate = Moment().format("YYYY-MM-DD");
        }

        if (!context.endDate) {
            context.endDate = Moment().format("YYYY-MM-DD");
        }

        DatepickerPlugin.init("#startDate", function (value) {
            context.startDate.value = value;
        });
        ClockpickerPlugin.init("#startTime", function (value) {
            context.startTime.value = value;
        });

        DatepickerPlugin.init("#endDate", function (value) {
            context.endDate.value = value;
        });
        ClockpickerPlugin.init("#endTime", function (value) {
            context.endTime.value = value;
        });

        context.getUserGroupData();
    },
};
</script>

<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 200px;
}

.pdf-container {
    /* display: flex; */
    justify-content: center;
    align-items: center;
    height: 100vh; /* Set the container height to 100% of the viewport height */
}

.checkbox-selection {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 5px !important;
    height: 45px !important;
}
</style>



// WEBPACK FOOTER //
// Form.vue?34ef6120